"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.IconWrapper = exports.AlertText = exports.Alert = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = exports.Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 128px;\n  flex-direction: column;\n  border-style: solid;\n  border-color: var(--color-neutral-90);\n  border-width: var(--border-width-hairline) 0 0 0;\n  padding: 0 var(--font-size-xs);\n"])));
var Alert = exports.Alert = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var AlertText = exports.AlertText = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  text-align: center;\n  color: var(--color-neutral-120);\n"])));
var IconWrapper = exports.IconWrapper = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: var(--color-neutral-110);\n  font-size: 25px;\n  padding-bottom: 10px;\n"])));